// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TabContent{height:100%;width:100%}.TabContent .loading-spinner-container{align-items:center;display:flex;justify-content:center}", ""]);
// Exports
module.exports = exports;
